import React from 'react';
import _ from 'lodash';
import { styled } from '@this/constants/themes';

import Segment from '@this/src/domain/transit/segment2';
import type LegSummary from '@this/src/domain/transit/leg_summary';
import ElementTransportBoxShortdistanceModalWindowTemplate from './transport_box_shortdistance_modal.template';

type Props = {
  segment: Segment;
  legsummary: LegSummary;
  i: number;
  j: number;
};

const ElementTransportBoxShortdistance: React.FC<Props> = ({ segment, legsummary, i, j }) => (
  <StyledSegment
    key={`${i}_${j}`}
    className={
      legsummary.type === 'jr' || legsummary.type === 'air'
        ? 'select-transport-box__button_exist_leg_shortdistance'
        : ''
    }
  >
    <StyledSummary>
      {legsummary.from.expressStation && legsummary.from.expressStation !== legsummary.from.name && (
        <StyledBoxContentThin>
          <StyledLegTime />
          <div>乗車駅: {legsummary.from.name}</div>
        </StyledBoxContentThin>
      )}
      <StyledBoxContent>
        <StyledLegTime>{legsummary.from.time}</StyledLegTime>
        <StyledBoxTitle>出発</StyledBoxTitle>
        <StyledSpace
          className={
            legsummary.type === 'jr' || legsummary.type === 'air'
              ? 'select-transport-box__button_exist_leg_station'
              : ''
          }
        >
          {legsummary.from.expressStation ? legsummary.from.expressStation : legsummary.from.name}
        </StyledSpace>
      </StyledBoxContent>
      <StyledBoxContent>
        <StyledLegTime />
        <StyledImageBox>{legsummary.type === 'jr' && <StyledImage src="/images/train.png" />}</StyledImageBox>
        <StyledImageBox>
          <StyledImage src={Segment.imagePathByName(legsummary.name)} />
        </StyledImageBox>
        {legsummary.type === 'air' || legsummary.type === 'jr' ? (
          <StyledSpaceName>{legsummary.name}</StyledSpaceName>
        ) : (
          <StyledSpaceName />
        )}
        <ElementTransportBoxShortdistanceModalWindowTemplate segment={segment} legsummary={legsummary} />
      </StyledBoxContent>
      <StyledBoxContent>
        <StyledLegTime>{legsummary.to.time}</StyledLegTime>
        <StyledBoxTitle>到着</StyledBoxTitle>
        <StyledSpace
          className={
            legsummary.type === 'jr' || legsummary.type === 'air'
              ? 'select-transport-box__button_exist_leg_station'
              : ''
          }
        >
          {legsummary.to.expressStation ? legsummary.to.expressStation : legsummary.to.name}
        </StyledSpace>
      </StyledBoxContent>
      {legsummary.to.expressStation && legsummary.to.expressStation !== legsummary.to.name && (
        <StyledBoxContentThin>
          <StyledLegTime />
          <div>降車駅: {legsummary.to.name}</div>
        </StyledBoxContentThin>
      )}
    </StyledSummary>
  </StyledSegment>
);

const StyledBoxContent = styled.div`
  display: flex;
  padding: 5px;
  color: #999999;
`;

const StyledBoxContentThin = styled.div`
  display: flex;
  padding: 2px;
  color: #999999;
  font-size: 0.7em;
`;

const StyledSegment = styled.div`
  padding: 5px 0;
  margin: 0;
  border: 1px solid #eeeeee;
  display: flex;
`;

const StyledSummary = styled.div`
  padding: 0;
  margin: 0;
  display: block;
`;

const StyledImageBox = styled.div`
  display: flex;
  min-width: 20px;
  margin-right: 5px;
`;

const StyledImage = styled.img`
  height: 15px;
  margin-left: 5px;
`;

const StyledBoxTitle = styled.div`
  background: #aaa;
  color: white;
  width: 25px;
  margin-right: 10px;
  height: 18px;
  font-size: 10px;
  font-weight: bold;
  line-height: 18px;
  text-align: center;
  vertical-align: middle;
`;

const StyledLegTime = styled.div`
  width: 50px;
  color: #1e90ff;
  font-size: 13px;
  font-weight: bold;
  height: 16px;
  vertical-align: middle;
`;

const StyledSpace = styled.div`
  margin-right: 10px;
  font-size: 0.9em;
`;

const StyledSpaceName = styled.div`
  margin-right: 10px;
  font-size: 0.8em;
`;

export default ElementTransportBoxShortdistance;
